import { UserService } from '../services/user.service';
import { TokenService } from '../services/storage.service';
import { DocumentService } from '../services/document.service';
import {
    REQUEST_BASE_FOLDER_ID,
    ROLE_CONSUMERS,
    ROLE_USERS_RES,
    ROLE_USERS_ROES,
    FOLDER_CODENAME_USER_FOLDER,
    FOLDER_CODENAME_USER_PROCESS_FOLDER
} from '../config/consts';

// initial state
const state = {
    userDataLoading: false,
    userData: {
        id: '',
        data: {
            iin: '',
            email: '',
            accounts: [],
            fullName: '',
            needSign: false
        },
        stamp: 0,
        active: true,
        login: '',
        psw: '',
        systemRole: [
            {
                id: '',
                data: {
                    name: ''
                },
                stamp: 0,
                active: true,
                code: '0',
                systemActions: []
            }
        ]
    },
    userBaseFolderId: '',
    userFolders: []
};

// getters
const getters = {
    isConsumer(state) {
        return state.userData && state.userData.systemRole ? state.userData.systemRole[0].code === ROLE_CONSUMERS : false;
    },
    isROESUser(state) {
        return state.userData && state.userData.systemRole ? state.userData.systemRole[0].code === ROLE_USERS_ROES : false;
    },
    isRESUser(state) {
        return state.userData && state.userData.systemRole ? state.userData.systemRole[0].code === ROLE_USERS_RES : false;
    },
    userAccounts(state) {
        if (state.userData && state.userData.data && state.userData.data.accounts) {
            return state.userData.data.accounts;
        } else {
            return [];
        }
    },
    userFullName(state) {
        if (state.userData && state.userData.data && state.userData.data.fullName) {
            return state.userData.data.fullName;
        } else {
            return '';
        }
    },
    userEmail(state) {
        if (state.userData && state.userData.data && state.userData.data.email) {
            return state.userData.data.email;
        } else {
            return '';
        }
    },
    userId(state) {
        return state.userData.id;
    },
    /**
     * Возвращает ID папки пользователя, для сохранения заявок по указанному процессу
     * @param {*} state
     * @param {*} processId - ID процесса
     */
    getFolderForRequests(state) {
        return function(processId) {
            if (state.userFolders.length > 0) {
                let item = state.userFolders.find(element => {
                    return element.data.code === 'userProcessFolder' && element.data.processId === processId;
                });
                if (item) {
                    return item.id;
                } else {
                    return undefined;
                }
            } else {
                return undefined;
            }
        };
    },
    userNeedSign(state, getters) {
        let result = false;
        // подпись используется у потребителя
        if (getters.isConsumer) {
            result = state.userData.data && typeof state.userData.data.needSign !== 'undefined' ? state.userData.data.needSign : true;
        }
        return result;
    }
};

// actions
const actions = {
    /**
     * Добавляет в схему доступные пользователю лицевые счёта. Для поля выбор лицевого счёта.
     */
    addAccountsToSchema({ getters }, { schemaIn, model }) {
        schemaIn.forEach(schema => {
            if (schema.code === 'accountsData' && schema.schema.fields) {
                schema.schema.fields.forEach(field => {
                    if (field.type === 'select' && field.code && field.code === 'accountNumber') {
                        if (getters.isROESUser || getters.isRESUser) {
                            field.type = 'input';
                            field.inputType = 'number';
                            field.validator = 'number';
                            delete field.selectOptions;
                            delete field.values;
                        } else {
                            field.values = [];
                            for (let i in getters.userAccounts) {
                                if (model && model.accountsData.account_number && model.accountsData.account_number === getters.userAccounts[i].account_id) {
                                    model.accountsData.account_number = getters.userAccounts[i];
                                }

                                field.values.push({
                                    name: getters.userAccounts[i].account_id,
                                    id: getters.userAccounts[i],
                                    accept: getters.userAccounts[i].accept

                                });
                            }

                            if (field.filter === 'notAcceptedOnly') {
                                field.values = field.values.filter(item => !item.accept);
                                if (field.values.length) return;
                                // Если акцепт был заполнен для всех лс
                                field.label = field.onAcceptEmpty;
                                field.label___Ru = field.onAcceptEmpty___Ru;
                                field.disabled = true;
                            }

                        }
                    }
                });
            }
        });
    },
    async loadUserData({ commit }) {
        if (TokenService.getToken()) {
            try {
                commit('setUserDataLoading', true);
                let userData = await UserService.getUsersCurrent();
                if (userData.data.accounts) {
                    userData.data.accounts.sort((a, b) => (a.account_id > b.account_id ? 1 : a.account_id < b.account_id ? -1 : 0));
                }

                if (
                    userData.systemRole[0].code === ROLE_CONSUMERS ||
                    userData.systemRole[0].code === ROLE_USERS_ROES ||
                    userData.systemRole[0].code === ROLE_USERS_RES
                ) {
                    // Для пользователей с ролью потребителя или ролью сотрудника РОЭС/РЭС
                    // определяем папки пользователя, для сохранения заявок
                    let userFolderData = await DocumentService.getUserDocumentFolders();
                    // все папки, кроме корневой папки пользователя
                    let userRequestFolders = userFolderData.filter(item => {
                        return item.data.code === FOLDER_CODENAME_USER_PROCESS_FOLDER;
                    });
                    commit('setUserFolders', userRequestFolders);
                    if (userData.systemRole[0].code === ROLE_CONSUMERS) {
                        // корневая папка для потребителя
                        let userRootFolderId = userFolderData.filter(item => {
                            return item.data.code === FOLDER_CODENAME_USER_FOLDER;
                        })[0].id;
                        commit('setUserBaseFolderId', userRootFolderId);
                    }
                    if (userData.systemRole[0].code === ROLE_USERS_ROES || userData.systemRole[0].code === ROLE_USERS_RES) {
                        // корневая папка для сотрдуника РОЭС/РЭС - папка "Все заявки"
                        commit('setUserBaseFolderId', REQUEST_BASE_FOLDER_ID);
                    }
                } else {
                    // для остальных - корнева папка, это папка "Все заявки". Личных папок нет.
                    commit('setUserFolders', []);
                    commit('setUserBaseFolderId', REQUEST_BASE_FOLDER_ID);
                }

                commit('setUserData', userData);
                return true;
            } catch (e) {
                console.log('user.loadUserData error: ' + e);
                return false;
            } finally {
                commit('setUserDataLoading', false);
            }
        }
    },
    async clearUserData({ commit }) {
        commit('setUserData', {});
        commit('setUserFolders', []);
        commit('setUserBaseFolderId', '');
    },
    async getAccountInfo({}, accountNumber) {
        try {
            let accountInfo = await UserService.getAccountInfo(accountNumber);
            return accountInfo;
        } catch (e) {
            console.log('user.getAccountInfo error: ' + e);
        }
    },
    async getAccountCntInfo({}, accountNumber) {
        try {
            let accountInfo = await UserService.getAccountCntInfo(accountNumber);
            return accountInfo;
        } catch (e) {
            console.log('user.getAccountInfo error: ' + e);
        }
    },
    async getAccountTariffInfo({}, accountNumber) {
        try {
            let accountInfo = await UserService.getAccountTariffInfo(accountNumber);
            return accountInfo;
        } catch (e) {
            console.log('user.getAccountInfo error: ' + e);
        }
    },
    async getAccountUnsealInfo({}, accountNumber) {
        try {
            let accountInfo = await UserService.getAccountUnsealInfo(accountNumber);
            return accountInfo;
        } catch (e) {
            console.log('user.getAccountInfo error: ' + e);
        }
    }
};

// mutations
const mutations = {
    setUserDataLoading(state, data) {
        state.userDataLoading = data;
    },
    setUserData(state, data) {
        state.userData = data;
    },
    setUserFolders(state, data) {
        state.userFolders = data;
    },
    setUserBaseFolderId(state, data) {
        state.userBaseFolderId = data;
    }
};

export const user = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
